if (!customElements.get('highlights-component')) {
  customElements.define(
    'highlights-component',
    class HighlightsComponent extends HTMLElement {
      connectedCallback() {
        this.hotspots = this.querySelectorAll('.highlights__hotspot');

        this.hotspots.forEach((hotspot) => {
          const trigger = hotspot.querySelector('.highlights__hotspot-trigger');
          if (trigger) {
            trigger.addEventListener('click', (e) => {
              e.stopPropagation();
              const isOpen = hotspot.getAttribute('aria-expanded') === 'true';
              this.closeAll();
              if (!isOpen) this.open(hotspot);
            });
          }
        });

        this.onDocClickBound = this.onDocumentClick.bind(this);
        this.onKeyDownBound = this.onKeyDown.bind(this);
        document.addEventListener('click', this.onDocClickBound);
        document.addEventListener('keydown', this.onKeyDownBound);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClickBound);
        document.removeEventListener('keydown', this.onKeyDownBound);
      }

      open(hotspot) {
        hotspot.setAttribute('aria-expanded', 'true');
      }

      closeAll() {
        this.hotspots.forEach((h) => h.setAttribute('aria-expanded', 'false'));
      }

      onDocumentClick(e) {
        if (!e.target.closest('.highlights__hotspot')) {
          this.closeAll();
        }
      }

      onKeyDown(e) {
        if (e.key === 'Escape') this.closeAll();
      }
    }
  );
}
